import {useStoredCompany} from "@/src/modules/company/store";
import {useCompanyOnGuardAssignees} from "@/src/modules/company-on-guard/hooks/use-company-on-guard-assignees";
import {companyOnGuardService} from "@/src/modules/company-on-guard/services";

import {DISPATCH_COVERAGE_REFETCH_INTERVAL_MS} from "./use-dispatch-coverage-rows";

const DISPATCH_ON_GUARD_PAGE_LIMIT = 50;

/** Company on-guard roster filtered to officers on duty right now (UTC schedule). */
export function useDispatchOnGuardOfficers() {
  const company = useStoredCompany();
  const companyId = company?.company_id;
  const canList = companyOnGuardService.getCanListRoster();

  return useCompanyOnGuardAssignees({
    companyId,
    enabled: canList && companyId != null,
    filter: {active_now: "1"},
    page: {limit: DISPATCH_ON_GUARD_PAGE_LIMIT, offset: 0},
    sort: "display_order",
    refetchInterval: DISPATCH_COVERAGE_REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: true,
  });
}
